import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82fe258c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "text-center text-uppercase" }
const _hoisted_5 = {
  key: 0,
  class: "recomendation mt-4"
}
const _hoisted_6 = { class: "recomendation mb-4" }
const _hoisted_7 = { class: "recomendation mt-4 mb-4" }
const _hoisted_8 = { class: "d-inline-flex justify-content-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container warning-modal pt-3", {'cart-modal': _ctx.isCartModal}])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", { src: _ctx.attention }, null, 8, _hoisted_2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AsahiTypography, {
          type: "headline-1",
          color: "primary-red"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Please note!')), 1)
          ]),
          _: 1
        })
      ]),
      (_ctx.messageHeading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_AsahiTypography, {
                type: "subtitle-medium",
                color: "primary-red"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.messageHeading)), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createVNode(_component_AsahiTypography, {
            type: "subtitle-medium",
            color: "primary-red"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.messageSubHeading)), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_AsahiTypography, {
            type: "subtitle-medium",
            color: "primary-red"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.messageAdditional)), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.secondaryButtonText)
            ? (_openBlock(), _createBlock(_component_AsahiButton, {
                key: 0,
                type: "secondary",
                class: "me-4",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.warningActionUser('no')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.secondaryButtonText)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.primaryButtonText && _ctx.isSapOutage)
            ? (_openBlock(), _createBlock(_component_AsahiButton, {
                key: 1,
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.primaryButtonText)), 1)
                ]),
                _: 1
              }))
            : (_ctx.primaryButtonText)
              ? (_openBlock(), _createBlock(_component_AsahiButton, {
                  key: 2,
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.warningActionUser('yes')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.primaryButtonText)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}